import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Biz360Logo } from "../components/layout/Biz360Logo";

export const DemoPage = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [status, setStatus] = useState("connecting");

  useEffect(() => {
    const connectDemo = async () => {
      try {
        await login("demo@biz360.fr", "demo2026");
        setStatus("success");
        setTimeout(() => {
          navigate("/dashboard");
        }, 1000);
      } catch (err) {
        setStatus("error");
        setTimeout(() => {
          navigate("/subscription");
        }, 2000);
      }
    };
    
    connectDemo();
  }, [login, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center" style={{background: 'linear-gradient(135deg, #FDFCFF 0%, #E8A87C20 100%)'}}>
      <div className="text-center p-8">
        <div className="flex justify-center mb-6">
          <Biz360Logo size={60} />
        </div>
        
        {status === "connecting" && (
          <>
            <div className="animate-spin w-12 h-12 border-4 border-[#E8A87C] border-t-transparent rounded-full mx-auto mb-4" />
            <h2 className="text-xl font-semibold mb-2" style={{color: '#210875'}}>
              Connexion à la démo...
            </h2>
            <p className="text-muted-foreground">
              Prépare-toi à découvrir Biz360 ❤️‍🔥
            </p>
          </>
        )}
        
        {status === "success" && (
          <>
            <div className="w-12 h-12 rounded-full bg-[#059669] flex items-center justify-center mx-auto mb-4">
              <svg className="w-6 h-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <h2 className="text-xl font-semibold mb-2" style={{color: '#059669'}}>
              Bienvenue en mode démo !
            </h2>
            <p className="text-muted-foreground">
              Redirection vers le tableau de bord...
            </p>
          </>
        )}
        
        {status === "error" && (
          <>
            <div className="w-12 h-12 rounded-full bg-[#B91C1C] flex items-center justify-center mx-auto mb-4">
              <svg className="w-6 h-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </div>
            <h2 className="text-xl font-semibold mb-2" style={{color: '#B91C1C'}}>
              Oups, erreur de connexion
            </h2>
            <p className="text-muted-foreground">
              Redirection vers l'inscription...
            </p>
          </>
        )}
      </div>
    </div>
  );
};
